<div class="row" *ngIf='readOnly'>
    <div class="col-md-12 col-sm-12 table-responsive no-border">
        <form [formGroup]="deviceForm" novalidate>
            <table class="table table-inner table-condensed  table-33">
                <tbody>
                    <tr>
                        <th role="columnheader" aria-label="Product Designer SRN">
                          Product Designer SRN
                        </th>
                    </tr>
                    <tr>
                        <td role="gridcell" aria-label="Cell of Product Designer SRN"
                          [ngClass]="isDefault('Product Designer SRN')">
                          <label controlName="productDesignerSRN"> </label>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table formArrayName="designerForm" class="table table-inner table-condensed  table-66">
                <tbody>
                    <tr>
                        <th role="columnheader" aria-label="Product Designer Name" class="col-sm-6">
                          Product Designer Name
                        </th>
                        <th role="columnheader" aria-label="Language" class="col-sm-6">
                          Language
                        </th>
                    </tr>
                    <ng-container *ngIf="designerForm.controls.length; else emptyTemplate2fields">
                    <tr formGroupName="{{i}}"
                        *ngFor="let sizeGroup of designerForm.controls; let i = index">
                        <td role="gridcell" aria-label="Cell of Product Designer Name"
                          [ngClass]="isDefault('Product Designer Names')">
                          <label controlName="name"></label>
                        </td>
                        <td role="gridcell" aria-label="Cell of Product Designer Name Language"
                          [ngClass]="isDefault('Product Designer Names')">
                          <label controlName="language"></label>
                        </td>
                    </tr>
                    </ng-container>
                </tbody>
            </table>
            <table class="table table-inner table-condensed ">
                <tbody>
                    <tr>
                        <th role="columnheader" aria-label="Street Name">
                          Street Name
                        </th>
                        <th role="columnheader" aria-label="Street Number">
                          Street Number
                        </th>
                        <th role="columnheader" aria-label="Address Complement">
                          Address Complement
                        </th>
                        <th role="columnheader" aria-label="PO Box">
                          PO Box
                        </th>
                        <th role="columnheader" aria-label="City">
                          City
                        </th>
                        <th role="columnheader" aria-label="Postal Code">
                          Postal Code
                        </th>
                        <th role="columnheader" aria-label="Country">
                          Country
                        </th>
                    </tr>
                    <tr>
                        <td role="gridcell" aria-label="Cell of Street Name" [ngClass]="isDefault('Street Name')">
                          <label controlName="streetName"></label>
                        </td>
                        <td role="gridcell" aria-label="Cell of Street Number" [ngClass]="isDefault('Street Number')">
                          <label controlName="streetNumber"></label>
                        </td>
                        <td role="gridcell" aria-label="Cell of Address Complement"
                          [ngClass]="isDefault('Address Complement')">
                          <label controlName="addressComplement"></label>
                        </td>
                        <td role="gridcell" aria-label="Cell of PO Box" [ngClass]="isDefault('PO Box')">
                          <label controlName="poBox"></label>
                        </td>
                        <td role="gridcell" aria-label="Cell of City" [ngClass]="isDefault('City')">
                          <label controlName="city"></label>
                        </td>
                        <td role="gridcell" aria-label="Cell of Postal Code" [ngClass]="isDefault('Postal Code')">
                          <label controlName="postalCode"></label>
                        </td>
                        <td role="gridcell" aria-label="Cell of Country" [ngClass]="isDefault('Country')">
                          <label controlName="country"></label>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table formArrayName="publicContactForm" class="table table-inner table-condensed  table-66">
                <tbody>
                    <tr>
                        <th role="columnheader" aria-label="Email" class="col-sm-6">
                          Email
                        </th>
                        <th role="columnheader" aria-label="Telephone" class="col-sm-6">
                          Telephone
                        </th>
                    </tr>
                    <ng-container *ngIf="publicContactForm.controls.length; else emptyTemplate2fields">
                    <tr formGroupName="{{i}}"
                        *ngFor="let sizeGroup of publicContactForm.controls; let i = index">
                        <td role="gridcell" aria-label="Cell of Email"
                          [ngClass]="isDefault('Product Designer Contacts')">
                          <label controlName="email"></label>
                        </td>
                        <td role="gridcell" aria-label="Cell of Telephone"
                          [ngClass]="isDefault('Product Designer Contacts')">
                          <label controlName="telephone"></label>
                        </td>
                    </tr>
                    </ng-container>
                </tbody>
            </table>
        </form>
    </div>
</div>
<ng-template #emptyTemplate2fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
